
import { authenticationService } from "../services/authentication.service";

export function authHeader() {
    // return authorization header with jwt token
    const currentUser = authenticationService.currentUserValue;
    if (currentUser && currentUser.Token) {
        return { Authorization: `Bearer ${currentUser.Token}` };
    } else {
        return {};
    }
}